module.exports = __webpack_public_path__ + "img/003.f1ff6a0e.jpg";